import React, {useState, useEffect} from "react";
const NA = () => { return <div style={{opacity:'0.3'}}>N/A</div>}

export default NA